var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFolderSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 57 57",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.16683 9.55127C7.84466 9.55127 7.5835 9.81244 7.5835 10.1346V47.4679C7.5835 47.7901 7.84465 48.0513 8.16683 48.0513H47.8335C48.1557 48.0513 48.4168 47.7901 48.4168 47.4679V17.1346C48.4168 16.8124 48.1557 16.5513 47.8335 16.5513H28.0002C27.4808 16.5513 26.9883 16.3206 26.6558 15.9216L21.3472 9.55127H8.16683ZM4.0835 10.1346C4.0835 7.87944 5.91167 6.05127 8.16683 6.05127H22.1668C22.6862 6.05127 23.1787 6.28196 23.5112 6.68095L28.8198 13.0513H47.8335C50.0887 13.0513 51.9168 14.8794 51.9168 17.1346V47.4679C51.9168 49.7231 50.0887 51.5513 47.8335 51.5513H8.16683C5.91168 51.5513 4.0835 49.7232 4.0835 47.4679V10.1346Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.4417 25.1136C39.1898 25.7256 39.3 26.8281 38.688 27.5762L28.188 40.4095C27.5807 41.1517 26.4892 41.2669 25.7403 40.6678L19.907 36.0012C19.1523 35.3974 19.0299 34.2962 19.6337 33.5414C20.2375 32.7867 21.3387 32.6644 22.0934 33.2681L26.5752 36.8535L35.9791 25.3598C36.5912 24.6118 37.6937 24.5015 38.4417 25.1136Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolderSuccess);
export default __webpack_public_path__ + "static/media/folder-success.78a717b8.svg";
export { ForwardRef as ReactComponent };